import { defineMessages } from 'react-intl-next';

export default defineMessages({
	deactivatedCreatorName: {
		id: 'rovo-chat.agent-card.deactivated-name',
		defaultMessage: '{name} (deactivated)',
		description: 'Name of the agent creator when it is deactivated',
	},
} as const);
